
// Definición de defaults

export const defaultMedioImpugnacionParams : MedioImpugnacionParams = {
    idMedioImpugnacion:         0,
    idTipoRecurso:              0,
    idAutoridadResolutoria:     0,
    idTipoResolucion:           0,
    idTipoRecurrente:           0,
    idParte:                    0,
    recurrente:                 '',
    idReferencia:               0,
}

export const defaultMedioImpugnacionDocumento: MedioImpugnacionDocumentoProps = {
    id:                 0,
    tipoAcuerdo:        '',
    subTipoAcuerdo:     '',
    nombre:             '',
    url:                '',
} 

export const defaultMedioImpugnacion: MedioImpugnacionProps = {
    idMedioImpugnacion:         0,
    idTipoRecurso:              0,
    tipoRecurso:                '',
    idAutoridadResolutoria:     0,
    autoridadResolutoria:       '',
    idTipoResolucion:           0,
    tipoResolucion:             '',
    idTipoRecurrente:           0,
    tipoRecurrente:             '',
    idParte:                    0,
    parte:                      '',
    recurrente:                 '',
    idReferencia:               0,
    medioImpugnacionDocumento:  defaultMedioImpugnacionDocumento,
}

// Creación de interfaces

export interface MedioImpugnacionParams {
    idMedioImpugnacion:         number;
    idTipoRecurso:              number;
    idAutoridadResolutoria:     number;
    idTipoResolucion:           number;
    idTipoRecurrente:           number;
    idParte:                    number;
    recurrente:                 string;
    idReferencia:               number;
}

export interface MedioImpugnacionProps extends MedioImpugnacionParams {
    tipoRecurso:                string;
    autoridadResolutoria:       string;
    tipoResolucion:             string;
    tipoRecurrente:             string;
    parte:                      string;
    fechaAdmision?:             Date;
    medioImpugnacionDocumento:  MedioImpugnacionDocumentoProps;
}

export interface MedioImpugnacionDocumentoProps {
    id:                 number;
    tipoAcuerdo:        string;
    subTipoAcuerdo:     string;
    nombre:             string;
    url:                string;
    fecha?:             Date;
}

export interface ObtenerMediosImpugnacionParams {
    idExpediente:   number;
    idEstatus:      number;
}

export interface ObtenerMediosImpugnacionSentenciaParams {
    idExpediente:   number;
}